// extracted by mini-css-extract-plugin
export var tooltip = "group-heading-module--tooltip--ede35";
export var tooltipContainer = "group-heading-module--tooltipContainer--58d31";